import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {BillingService} from '../../service/billing/billingService.js';
import {Service} from '../../service/service.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {ExportUtil} from '../../utils/exportUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {StringUtil} from '../../utils/stringUtil.js';
import {BaseComponent} from '../basecomponent.js';


/* global customElements */
class ReferralGrid extends BaseComponent {
	
	static get properties() {
		return {			
		};
	}
	
	constructor() {
		super();
		
		this.local = false;
		
		var referralGrid = this;
		setTimeout(function(){
			referralGrid.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var referralGrid = this;
		
		var toolbar = ElementUtil.create({
			tag: 'dl-toolbar',
			slot: 'toolbar',
			theme: 'spacing',
			children: [
				{
					tag: 'vaadin-button',
					itemid: 'refresh',
					'class': 'spacer-toolbar-item',
					children:[
						ElementUtil.makeIcon('vaadin:refresh', ' Refresh')
					], 
					listeners: {
						click: function() {
							actionRefresh();
						}
					}
				},
				{	
					tag: 'vaadin-combo-box',
					itemid: 'status',						
					'class': 'spacer-toolbar-item',
					'item-value-path': 'code',
					'item-label-path': 'desc',
					'prevent-invalid-input': true,
					postinit: function(combo) {							
						combo.items = [
							{
								code: 'A',
								desc: 'Active'
							}, {
								code: 'I',
								desc: 'Inactive'
							}
						];
						combo.value = 'A';
					},
					listeners: {
						'selected-item-changed': function(event) {
							if (actionRefresh){
								actionRefresh();
							}
						}
					}
										
				},
				{
					tag: 'dl-action-button',
					itemid: 'add',
					theme: 'primary',
					'class': 'spacer-toolbar-item',
					permissions: ['ADMIN_BILLING_REFERRALS:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:plus', ' Add')
					],
					listeners: {
						click: function() {							
							actionAddEdit();
						}
					}					
				},
				{
					tag: 'dl-action-button',
					itemid: 'edit',
					'class': 'spacer-toolbar-item',
					permissions: ['ADMIN_BILLING_REFERRALS:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:edit', ' Edit')
					],
					listeners: {
						click: function() {							
							actionAddEdit(grid.selectedItems[0]);
						}
					}
				},
				{
					tag: 'span',
					style: 'font-size: 24px; color: gray;',
					innerHTML: '|'
				},
				{
					tag: 'dl-action-button',
					itemid: 'balance',
					'class': 'spacer-toolbar-item',
					permissions: ['ADMIN_BILLING_REFERRALS:READ'],
					children:[
						ElementUtil.makeIcon('vaadin:scale', ' Balance')
					],
					listeners: {
						click: function() {							
							actionBalance(grid.selectedItems[0]);
						}
					}
				},				
				{			
					tag: 'dl-action-button',
					itemid: 'payments',
					'class': 'spacer-toolbar-item',
					permissions: ['ADMIN_BILLING_REFERRALS:READ'],
					children:[
						ElementUtil.makeIcon('vaadin:money', ' Payments')
					],
					listeners: {
						click: function() {							
							actionPayments(grid.selectedItems[0]);
						}
					}
				},				
				{
					tag: 'dl-action-button',
					itemid: 'updateStatus',
					'class': 'spacer-toolbar-item',
					permissions: ['ADMIN_BILLING_REFERRALS:UPDATE_STATUS'],
					style: 'float: right;',
					children:[
						ElementUtil.makeIcon('vaadin:check', ' Toggle Status')
					],
					listeners: {
						click: function() {							
							actionUpdateStatus(grid.selectedItems[0]);
						}
					}
				}		
			]
		});	
		
		
		var grid = ElementUtil.create({
			tag: 'vaadin-grid',
			theme: 'row-stripes column-borders',
			'column-reordering-allowed': '',
			style: 'height: 100%;',
			slot: 'primary',
			defaults: {
				tag: 'vaadin-grid-sort-column',
				resizable: true,
				listeners: {
					'direction-changed' : function(event) {
						if (event.detail && event.detail.value) {
							grid.currentSortField = event.target.path;
							grid.currentSortDirection = event.detail.value.toUpperCase();
							pagingToolbar.loadCurrentPage();
						}
					}
				}				
			},			
			children: [	
				{						
					path: 'referralProgramCode',
					header: 'Program',					
					width: '7em'
				},
				{						
					path: 'referralCode',
					header: 'Code',					
					width: '7em'
				},				
				{						
					path: 'signupName',
					header: 'Name',					
					'flex-grow': '1'					
				},
				{						
					path: 'signupDate',
					header: 'Signup Date',						
					width: '9em',
					renderer: function(root, column, rowData) {											
						root.innerHTML = TimeUtil.formatDateStringToStandard(TimeUtil.formatDateForDateLoadStriped(rowData.item.signupDate));
					}
				},
				{						
					path: 'referralBalanceModel.referralBalance.balanceAmt',
					header: 'Current Balance',					
					width: '9em',
					'text-align': 'end',
					renderer: function(root, column, rowData) {
						if (rowData.item.referralBalanceModel.referralBalance) {
							root.innerHTML = StringUtil.currencyFormat(rowData.item.referralBalanceModel.referralBalance.balanceAmt);
						} else {
							root.innerHTML = StringUtil.currencyFormat(0);
						}
					}
				}
			],
			listeners: {
				'active-item-changed': function(event) {
					const item = event.detail.value;
					grid.selectedItems = item ? [item] : [];
					if (grid.selectedItems.length > 0) {	
						
						ElementUtil.enableDisableAction(toolbar, 'edit', false);
						ElementUtil.enableDisableAction(toolbar, 'updateStatus', false);
						
						ElementUtil.query(toolbar, 'balance').disabled = false;
						ElementUtil.query(toolbar, 'payments').disabled = false;
					} else {						
						ElementUtil.enableDisableAction(toolbar, 'edit', true);
						ElementUtil.enableDisableAction(toolbar, 'updateStatus', true);
						
						ElementUtil.query(toolbar, 'balance').disabled = true;
						ElementUtil.query(toolbar, 'payments').disabled = true;
					}	
				}
			}
		});		
		
		var pagingToolbar = ElementUtil.create({
			tag: 'dl-paging-toolbar',
			slot: 'footer',
			pageSize: 200,
			postinit: function(element) {
				element.grid = grid;
				element.loader = function(backingGrid, pageNumber, pagingToolbar) {
					var pageRange = pagingToolbar.pullRange();
					var loadMask = grid.showLoading();
					
					referralGrid.currentFilter = {
						offset: pageRange.offset,
						max: pageRange.max,
						sortField: backingGrid.currentSortField,
						sortOrder: backingGrid.currentSortDirection,
						status: ElementUtil.query(toolbar, 'status').value						
					};
					
					var successHandler = function(records) {
						loadMask.remove();
						grid.activeItem = null;						
						grid.items = records.data;
						
						referralGrid.fullDataSet = records.data;						
						pagingToolbar.totalRecords = records.totalNumber;
						pagingToolbar.updatePager();						
					};
					
					BillingService.getReferralService().getReferrals(referralGrid.currentFilter)
					.then(function(records){							
						successHandler(records);
					});
										
				};
			},
			listeners: {
				ready: function() {					
					pagingToolbar.loadCurrentPage();
				}
			}
			
		});		
		
		var footer = ExportUtil.createExportFooter({
			pagingToolbar: pagingToolbar,
			grid: grid,
			itemid: 'referrals',
			onDetail: function() {
				ExportUtil.exportGridItemsAsCsv(grid.items, 'referrals.csv');
			}
		});

		var flexLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [
				toolbar,
				grid,
				footer.footerContainer
			]
		});		
		referralGrid.append(flexLayout);		
		
		
		var actionRefresh = function() {
			pagingToolbar.loadPage(1);			
		};
		
		var actionAddEdit = function(record) {
			
			var addEditWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Add/Edit Referral',
				icon: 'lumo:edit',
				listeners: {
					ready: function() {						
						addEditWin.show();
													
							var formPanel = ElementUtil.create({
							tag: 'dl-form-panel',
							itemid: 'form',
							children: [
								{
									tag: 'vaadin-form-layout',										
									children: [
										{
											tag: 'vaadin-text-field',
											label: 'Code',
											name: 'referralCode',
											required: true,
											maxlength: 80
										},	
										{
											tag: 'vaadin-text-field',											
											label: 'Signup Name',
											name: 'signupName',											
											required: true,
											maxlength: 40																						
										},
										{
											tag: 'vaadin-text-field',
											label: 'Approved By',
											name: 'referralApprovedBy',											
											maxlength: 120
										},
										{
											tag: 'vaadin-text-field',
											label: 'Payment Reference',
											name: 'referralPaymentRef',											
											maxlength: 255
										},
										{
											tag: 'vaadin-date-picker',
											itemId: 'signupDate',
											label: 'Signup Date',
											name: 'signupDate',
											required: true
										},										
										{
											tag: 'vaadin-combo-box',									
											label: 'Payment Type', 
											name: 'referralPaymentType',
											'item-value-path': 'code',
											'item-label-path': 'description',
											required: true,
											postinit: function(combo) {
												Service.getLookupService().getLookupValues('ReferralPaymentType').then(function(data){
													combo.items = data;
												});
											}
										},
										{
											tag: 'vaadin-combo-box',											
											label: 'Program', 
											name: 'referralProgramCode',
											'item-value-path': 'code',
											'item-label-path': 'description',
											required: true,
											postinit: function(combo) {
												BillingService.getReferralService().getReferralPrograms().then(function(programs){
													var lookups = [];
													programs.data.forEach(function(program){
														lookups.push({
															code: program.referralProgram.referralProgramCode,
															description: program.referralProgram.referralProgramName
														});
													});													
													combo.items = lookups;
												});
											}
										},
										{
											tag: 'hr',
											colspan: 2
										},
										{
											tag: 'vaadin-text-field',
											label: 'Address Line 1',
											name: 'addressLine1',	
											required: true,
											maxlength: 255
										},
										{
											tag: 'vaadin-text-field',
											label: 'Address Line 2',
											name: 'addressLine2',											
											maxlength: 255
										},	
										{
											tag: 'vaadin-text-field',
											label: 'Address Line 3',
											name: 'addressLine3',												
											maxlength: 255
										},
										{
											tag: 'vaadin-text-field',
											label: 'Postal Code',
											name: 'postalCode',
											required: true,
											maxlength: 40
										},
										{
											tag: 'vaadin-text-field',
											label: 'City',
											name: 'cityName',
											required: true,
											maxlength: 80
										},
										{
											tag: 'vaadin-combo-box',
											itemid: 'state',
											label: 'State/Providence', 
											name: 'stateProvCode',
											'item-value-path': 'code',
											'item-label-path': 'description',
											required: true,
											postinit: function(combo) {
												Service.getLookupService().getLookupValues('StateProvCode').then(function(data){
													combo.items = data;
												});
											}
										},										
										{
											tag: 'hr',
											colspan: 2
										},
										{
											tag: 'div',
											style: 'text-align: center;',
											colspan: 2,
											defaults: {
												tag: 'vaadin-button'
											},
											children: [
												{
													theme: 'primary',
													children: [
														ElementUtil.makeIcon('vaadin:database', ' Save')
													],
													listeners: {
														click: function() {															
																
															formPanel.submitForm({
																preSubmit: function(data) {
																	data.country = ElementUtil.query(formPanel, 'state').selectedItem.country;																	
																	data.signUpDateRaw = TimeUtil.formatDateOnlyFromDate(data.signupDate);
																	
																	return data;
																},
																actualCall: function(data) {																
																	return BillingService.getReferralService().saveReferral(data, record ? true : false);
																},
																success: function(data, responseData) {
																	window.DL.MessageUtil.showToast('Success', 'Saved Reference Company', {
																		theme: 'success',
																		position: 'top-stretch'
																	});
																	if (formPanel.successCallback) {
																		formPanel.successCallback();
																	}
																	actionRefresh();
																	addEditWin.close();
																}
															});
															
														}
													}
												},
												{
													theme: 'tertiary',
													innerHTML: 'Cancel',
													style: 'margin-left: 10px;',
													listeners: {
														click: function() {
															//cancel
															addEditWin.close();
														}
													}
												}
											]
										}
									]
								}
							]

						});
						addEditWin.addToContentElement(formPanel);	
						
						if (record) {	
							
							var loadModel = Object.assign({}, record);
							loadModel.signupDate = TimeUtil.formatDateStringToStandard(TimeUtil.formatDateForDateLoadStriped(record.signupDate));
							if (loadModel.signupDate.startsWith('0')) {
								loadModel.signupDate = loadModel.signupDate.substring(1);
							}
							
							formPanel.load(loadModel);	
							
						}
					}
				}
			});
		
						
		};
		
		
		var actionBalance = function(record) {
			var balanceWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Balance',
				icon: 'vaadin:scale',
				listeners: {
					ready: function() {						
						balanceWin.show();	
						
						var balanceToolbar = ElementUtil.create({
							tag: 'dl-toolbar',
							slot: 'toolbar',
							theme: 'spacing',
							children: [
								{
									tag: 'vaadin-button',
									itemid: 'details',
									theme: 'primary',
									'class': 'spacer-toolbar-item',
									children:[
										ElementUtil.makeIcon('lumo:eye', ' Details')
									], 
									listeners: {
										click: function() {
											actionViewDetails(balanceGrid.selectedItems[0]);
										}
									}
								}
							]
						});				

						var balanceGrid = ElementUtil.create({
							tag: 'vaadin-grid',
							theme: 'row-stripes column-borders',
							'column-reordering-allowed': '',
							style: 'height: 100%;',
							slot: 'primary',
							defaults: {
								tag: 'vaadin-grid-sort-column',
								resizable: true			
							},			
							children: [									
								{						
									path: 'updateDts',
									header: 'Date',						
									width: '9em',
									renderer: function(root, column, rowData) {											
										root.innerHTML = TimeUtil.formatDateStandard(rowData.item.updateDts);
									}
								},
								{						
									path: 'balanceAmt',
									header: 'Balance',					
									width: '9em',
									'text-align': 'end',
									renderer: function(root, column, rowData) {
										root.innerHTML = StringUtil.currencyFormat(rowData.item.balanceAmt);
									}
								}
							],
							listeners: {
								'active-item-changed': function(event) {
									const item = event.detail.value;
									balanceGrid.selectedItems = item ? [item] : [];
									if (balanceGrid.selectedItems.length > 0) {						
										ElementUtil.query(balanceToolbar, 'details').disabled = false;
									} else {						
										ElementUtil.query(balanceToolbar, 'details').disabled = true;
									}	
								}
							}
						});				
						
						var content = ElementUtil.create({
							tag: 'dl-flex-layout',
							children: [
								balanceToolbar,
								balanceGrid
							]
						});
						balanceWin.addToContentElement(content);
						
						var actionRefreshBalance = function() {
							
							var loadMask = balanceGrid.showLoading();
							BillingService.getReferralService().getBalanceHistory(record.referralCode).then(function(data) {
								loadMask.remove();
								balanceGrid.activeItem = null;
								balanceGrid.items = data;	
							});
						};
						actionRefreshBalance();
						
						var actionViewDetails = function(balance) {
							
							var balanceDetailWin = ElementUtil.create({
								tag: 'dl-dialog',
								title: 'Balance Details - ' + TimeUtil.formatDateStandard(balance.updateDts),
								icon: 'vaadin:scale',
								listeners: {
									ready: function() {						
										balanceDetailWin.show();	
										
										var balanceDetailGrid = ElementUtil.create({
											tag: 'vaadin-grid',
											theme: 'row-stripes column-borders',
											'column-reordering-allowed': '',
											style: 'height: 100%;',
											slot: 'primary',
											defaults: {
												tag: 'vaadin-grid-sort-column',
												resizable: true			
											},			
											children: [		
												{
													path: 'productCode',
													header: 'Product Code',						
													width: '9em'
												},
												{
													path: 'featureProductCode',
													header: 'Product Code',						
													width: '9em'
												},
												{
													path: 'companyName',
													header: 'Company Name',						
													width: '9em'
												},
												{						
													path: 'updateDts',
													header: 'Date',						
													width: '9em',
													renderer: function(root, column, rowData) {											
														root.innerHTML = TimeUtil.formatDateOnlyStandard(rowData.item.updateDts);
													}
												},
												{						
													path: 'referralAmount',
													header: 'Balance',					
													width: '9em',
													'text-align': 'end',
													renderer: function(root, column, rowData) {
														root.innerHTML = StringUtil.currencyFormat(rowData.item.referralAmount);
													}
												}
											]
										});	
																				
										balanceDetailWin.addToContentElement(ElementUtil.create({
											tag: 'dl-flex-layout',
											children: [
												balanceDetailGrid
											]
										}));
										
										var actionRefreshBalanceDetails = function() {
							
											var loadMask = balanceDetailGrid.showLoading();
											BillingService.getReferralService().getBalanceHistoryDetails(record.referralCode, balance.balanceId).then(function(data) {
												loadMask.remove();
												balanceDetailGrid.activeItem = null;
												balanceDetailGrid.items = data;	
											});
										};
										actionRefreshBalanceDetails();
										
									}
								}
							});
							
						};
						
					}
				}
			});
			
		};
		
		var actionPayments = function(record) {
			var paymentWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Payments',
				icon: 'vaadin:money',
				listeners: {
					ready: function() {						
						paymentWin.show();	
						
						var paymentsToolbar = ElementUtil.create({
							tag: 'dl-toolbar',
							slot: 'toolbar',
							theme: 'spacing',
							children: [
								{
									tag: 'dl-action-button',
									itemid: 'payment',
									theme: 'primary',
									'class': 'spacer-toolbar-item',
									permissions: ['ADMIN_BILLING_REFERRALS:WRITE'],
									children:[
										ElementUtil.makeIcon('vaadin:edit', ' Record Payment')
									], 
									listeners: {
										click: function() {
											actionRecordPayment();
										}
									}
								}
							]
						});				

						var paymentsGrid = ElementUtil.create({
							tag: 'vaadin-grid',
							theme: 'row-stripes column-borders',
							'column-reordering-allowed': '',
							style: 'height: 100%;',
							slot: 'primary',
							defaults: {
								tag: 'vaadin-grid-sort-column',
								resizable: true			
							},			
							children: [									
								{						
									path: 'referralPaymentType',
									header: 'Payment Type',						
									width: '9em'
								},
								{						
									path: 'paymentReferenceNo',
									header: 'Reference No',						
									width: '9em'
								},
								{						
									path: 'paymentDate',
									header: 'Date',						
									width: '9em',
									renderer: function(root, column, rowData) {											
										root.innerHTML = TimeUtil.formatDateStandard(rowData.item.paymentDate);
									}
								},
								{						
									path: 'paymentAmt',
									header: 'Amount',					
									width: '9em',
									'text-align': 'end',
									renderer: function(root, column, rowData) {
										root.innerHTML = StringUtil.currencyFormat(rowData.item.paymentAmt);
									}
								}
							]
						});				
						
						var content = ElementUtil.create({
							tag: 'dl-flex-layout',
							children: [
								paymentsToolbar,
								paymentsGrid
							]
						});
						paymentWin.addToContentElement(content);
						
						var actionRefreshPayments = function() {
							
							var loadMask = paymentsGrid.showLoading();
							BillingService.getReferralService().getPayments(record.referralCode).then(function(data) {
								loadMask.remove();
								paymentsGrid.activeItem = null;
								paymentsGrid.items = data;	
							});
						};
						actionRefreshPayments();						
						
						var actionRecordPayment = function() {
							
							var recordPaymentWin = ElementUtil.create({
								tag: 'dl-dialog',
								title: 'Record Payment',
								icon: 'vaadin:edit',
								width: 500,
								height: 300,
								listeners: {
									ready: function() {						
										recordPaymentWin.show();	
										
										//form
										var formPanel = ElementUtil.create({
											tag: 'dl-form-panel',
											itemid: 'form',
											children: [
												{
													tag: 'vaadin-form-layout',										
													children: [
														{
															tag: 'vaadin-date-picker',
															label: 'Payment Date',
															name: 'paymentDate',
															required: true
														},	
														{
															tag: 'vaadin-text-field',
															label: 'Reference Number',
															name: 'paymentReferenceNo',											
															required: true,
															maxlength: 255																						
														},
														{
															tag: 'vaadin-number-field',
															label: 'Amount',
															name: 'paymentAmt',
															required: true,
															min: -9999999,
															max: 9999999
														},									
														{
															tag: 'hr',
															colspan: 2
														},
														{
															tag: 'div',
															style: 'text-align: center;',
															colspan: 2,
															defaults: {
																tag: 'vaadin-button'
															},
															children: [
																{
																	theme: 'primary',
																	children: [
																		ElementUtil.makeIcon('vaadin:database', ' Save')
																	],
																	listeners: {
																		click: function() {															

																			formPanel.submitForm({
																				preSubmit: function(data) {
																					data.currencyCode = 'USD';
																					data.referralCode = record.referralCode;																					
																					data.referralPaymentType = record.referralPaymentType;
																					return data;
																				},
																				actualCall: function(data) {																				
																					return BillingService.getReferralService().recordPayment(data);
																				},
																				success: function(data, responseData) {
																					window.DL.MessageUtil.showToast('Success', 'Posted Payment', {
																						theme: 'success',
																						position: 'top-stretch'
																					});																					
																					actionRefreshPayments();
																					recordPaymentWin.close();
																				}
																			});

																		}
																	}
																},
																{
																	theme: 'tertiary',
																	innerHTML: 'Cancel',
																	style: 'margin-left: 10px;',
																	listeners: {
																		click: function() {
																			//cancel
																			recordPaymentWin.close();
																		}
																	}
																}
															]
														}
													]
												}
											]

										});
										recordPaymentWin.addToContentElement(formPanel);	
										
										
									}
								}
							});
							
						};
						
					}
				}
			});			
		};
		
		var actionUpdateStatus = function(record) {
			var loadMask = grid.showLoading('Updating...');	
			if (record.activeStatus === 'A') {
				BillingService.getReferralService().deleteReferral(record.referralCode).then(function(){
					loadMask.remove();				
					actionRefresh();
				});	
			} else {
				BillingService.getReferralService().activateReferral(record.referralCode).then(function(){
					loadMask.remove();				
					actionRefresh();
				});
			}
		};		
	

	}
	
};
customElements.define('dl-referral-grid', ReferralGrid);


